<div class="package-form">
  <h2 mat-dialog-title>
    {{ isEditMode ? 'Rename Invoice Template' : 'Create New Invoice Template' }}
    <button
      mat-icon-button
      mat-dialog-close
      aria-label="Close dialog"
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="form-group">
        <label for="name">Name</label>
        <input
          type="text"
          id="name"
          formControlName="name"
          class="lum-input form-control"
        />
        <mat-error *ngIf="nameControl && nameControl.invalid">
          <small>
            {{ nameControl | validateField }}
          </small>
        </mat-error>
      </div>
    </form>
    <div>
      <!-- Your content goes here -->
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="lum-button lum-button--tertiary mr-2" mat-dialog-close>
      Cancel
    </button>
    <button class="lum-button" (click)="onSubmit()" [disabled]="form.invalid">
      Save
    </button>
  </mat-dialog-actions>
</div>
